import { render } from "./ZaikoMovePage.vue?vue&type=template&id=039c0e0f"
import script from "./ZaikoMovePage.vue?vue&type=script&lang=js"
export * from "./ZaikoMovePage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__